import { normalize, schema } from 'normalizr';
import { EventActionViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';
import * as EventNormalizers from './eventNormalizers';
import * as UserNormalizers from './userNormalizers';

const { Entity } = schema;

export interface NormalizedEventActions extends EventNormalizers.NormalizedEvents {
  eventActions: ById<EventActionViewModel>;
}

export const eventActionsSchema = new Entity('eventActions', {
  event: EventNormalizers.eventSchema,
  user: UserNormalizers.userSchema,
});

export function normalizeEventActionsArray(
  data: EventActionViewModel[],
): EntityNormalizers.NormalizedEntityArray<NormalizedEventActions> {
  return normalize(data, new schema.Array(eventActionsSchema));
}
